import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "event",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loadEvent(_ctx.id)))
  }, [
    _createElementVNode("h3", null, _toDisplayString(_ctx.title), 1),
    _createElementVNode("i", null, _toDisplayString(_ctx.startDate.toLocaleString()) + " - " + _toDisplayString(_ctx.startDate.getDate() === _ctx.endDate.getDate()
          ? _ctx.endDate.toLocaleTimeString()
          : _ctx.endDate.toLocaleString()), 1),
    _createElementVNode("p", null, _toDisplayString(_ctx.description), 1),
    _cache[1] || (_cache[1] = _createElementVNode("button", null, "View details", -1))
  ]))
}